import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  isAdminUser,
  isPartnerAdmin,
} from "../../admin/navigation/adminNavigation";

const AdminAndPartnerProtected = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();

  if (isAdminUser(authState) || isPartnerAdmin(authState)) {
    return children;
  }

  return (
    <Navigate
      to="/admin-login"
      replace
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
    />
  );
};

export default AdminAndPartnerProtected;
